import { render, staticRenderFns } from "./InvestorHoldings.vue?vue&type=template&id=9cb425c2&scoped=true"
import script from "./InvestorHoldings.vue?vue&type=script&lang=js"
export * from "./InvestorHoldings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb425c2",
  null
  
)

export default component.exports